import { nonUnionApplies } from './jointdecStrataRegression';

export const PRACTICE_RISK_LABEL_TO_FIELD = {
  Death: 'death_surgery',
  Stroke: 'stroke_surgery',
  'Myocardial Infarction': 'mi_surgery',
  'Pulmonary Embolism': 'pe_surgery',
  'Deep Vein Thrombosis': 'dvt_surgery',
  'Surgical Site Infection': 'surgical_site_infection',
  'Neurological Injury': 'neurological_injury',
  'Postoperative Bleeding/Wound Hematoma': 'postop_bleeding_hematoma',
  'Intraoperative Incidental Durotomy': 'intraop_durotomy',
  'Vascular Injury': 'vascular_injury',
  'Visceral Organ Injury': 'visceral_organ_injury',
  'Revision Surgery': 'revision_surgery_1yr',
  'Adjacent Segment Disease': 'adjacent_segment_disease',
  'Non-Union': 'non_union',
  Reherniation: 'reherniation',
  'Abdominal Hernia': 'abdominal_hernia',
};

function finiteNumber(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function practiceRateForRisk(stats, procedureKey, riskLabel) {
  if (riskLabel === 'Non-Union' && !nonUnionApplies(procedureKey)) return null;
  const field = PRACTICE_RISK_LABEL_TO_FIELD[riskLabel];
  if (!field || !procedureKey || !stats) return null;
  return finiteNumber(stats.by_procedure?.[procedureKey]?.complications?.[field]?.rate);
}

export function practiceBenefitMean(stats, procedureKey, outcomeKey) {
  if (!procedureKey || !stats || !outcomeKey) return null;
  return finiteNumber(stats.by_procedure?.[procedureKey]?.benefits?.[outcomeKey]?.mean);
}

export function practiceProcedureSample(stats, procedureKey) {
  const slice = stats?.by_procedure?.[procedureKey];
  if (!slice) return { n: 0, matchedOn: [] };
  return {
    n: Number(slice.n) || 0,
    matchedOn: Array.isArray(slice.matched_on) ? slice.matched_on : [],
  };
}

export function formatPracticeMatchCaption(stats, procedureKey, { overallN } = {}) {
  if (!stats) return '';
  const sample = practiceProcedureSample(stats, procedureKey);
  const useOverall =
    Boolean(overallN) ||
    Boolean(stats.pool_all) ||
    sample.matchedOn.includes('all_surgeries');
  if (useOverall) {
    const n = Number(stats.n_practice) || sample.n || 0;
    return `n = ${n}, all surgeries`;
  }
  const n = sample.n || Number(stats.n_practice) || 0;
  const matched = sample.matchedOn.filter((key) => key && key !== 'procedure_key');
  const matchText = matched.length ? `matched on ${matched.join(' + ')}` : 'procedure only';
  return `n = ${n}, ${matchText}`;
}
